import { render, staticRenderFns } from "./goWechat.vue?vue&type=template&id=b07e90c8"
import script from "./goWechat.vue?vue&type=script&lang=js"
export * from "./goWechat.vue?vue&type=script&lang=js"
import style0 from "./goWechat.vue?vue&type=style&index=0&id=b07e90c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports